import type { Theme } from '../../types/theme';

export const airbnbTheme: Theme = {
  id: 'airbnb',
  name: 'Airbnb',
  description: 'Warm, photography-driven marketplace design. Rausch coral CTAs and generous rounded corners.',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/airbnb/DESIGN.md',
  visualKeywords: ['warm', 'coral', 'rounded', 'photo-first', 'friendly', 'marketplace'],
  colors: {
    background: '#ffffff',
    surface: '#f7f7f7',
    surfaceElevated: '#ffffff',
    surfaceDark: '#222222',
    textPrimary: '#222222',
    textSecondary: '#3f3f3f',
    textMuted: '#6a6a6a',
    border: '#dddddd',
    borderSubtle: '#ebebeb',
    primary: '#ff385c',
    primaryHover: '#e00b41',
    primaryActive: '#c7224f',
    accent: '#ff385c',
    onPrimary: '#ffffff',
    success: '#008a05',
    warning: '#c26b00',
    error: '#c13515',
  },
  typography: {
    headingFont: 'Circular, -apple-system, BlinkMacSystemFont, sans-serif',
    bodyFont: 'Circular, -apple-system, BlinkMacSystemFont, sans-serif',
    monoFont: 'Circular, sans-serif',
    headingWeight: '700',
    bodyWeight: '400',
    letterSpacingHeading: '-0.44px',
    letterSpacingBody: '0',
  },
  radius: {
    button: '8px',
    card: '14px',
    panel: '20px',
    badge: '9999px',
    input: '8px',
  },
  shadow: {
    card: '0 0 0 1px rgba(0,0,0,0.02), 0 2px 6px rgba(0,0,0,0.04), 0 4px 8px rgba(0,0,0,0.1)',
    elevated: '0 6px 16px rgba(0,0,0,0.15)',
    button: 'none',
    none: 'none',
  },
  layout: {
    maxWidth: '1120px',
    sectionSpacing: '64px',
    cardPadding: '24px',
    navHeight: '80px',
  },
  mood: {
    density: 'medium',
    tone: 'warm, friendly, travel-inspired',
    productFit: ['Marketplaces', 'Travel platforms', 'Consumer services', 'Community products'],
    bestFor: ['Two-sided marketplaces', 'Travel & hospitality', 'Consumer-facing brands', 'Community platforms'],
    notGoodFor: ['Developer tools', 'B2B products', 'Data analytics', 'Security products'],
  },
};
